import { render, staticRenderFns } from "./TabItem.vue?vue&type=template&id=0fd9861a&"
import script from "./TabItem.vue?vue&type=script&lang=ts&"
export * from "./TabItem.vue?vue&type=script&lang=ts&"
import style0 from "./TabItem.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports